import React, { useCallback, useEffect, useState } from 'react';
import Icon from './icon';
import ToastBannerProps from '../../Interfaces/ToastBannerInterface';
import './ToastBanner.scss';
import useStore from '../../../store/useStore';

type AlertType = 'success' | 'warning' | 'error' | 'info';
type AlertDetail = { message: string; type: AlertType };

export const Alert = (detail: AlertDetail) => {
  window.dispatchEvent(
    new CustomEvent('toastAlert', {
      detail,
    }),
  );
};

const ToastBanner: React.FC<ToastBannerProps> = ({ duration = 2000, styleAlert }) => {
  const [alerts, setAlerts] = useState<AlertDetail[]>([]);
  const {
    isHideToastBanner,
    removeToastBanner,
    setAnalyticsProducts,
    headerHeightCal,
    isHeaderLoad,
  } = useStore();

  const handler = useCallback(
    ({ detail }: CustomEvent<AlertDetail>) => {
      setAlerts(prevAlerts => [...prevAlerts, detail]);

      setTimeout(() => {
        setAlerts(prevAlerts => prevAlerts.slice(1, prevAlerts.length));
        isHideToastBanner();
        removeToastBanner();
        setAnalyticsProducts({});
        window.orderViewModel.redirectBannerMessage = '';
        window.orderViewModel.showRedirectSuccessBanner = false;
        window.orderViewModel.save();
      }, duration);
    },
    [duration],
  );

  useEffect(() => {
    window.addEventListener('toastAlert', handler as () => void);

    return () => {
      window.removeEventListener('toastAlert', handler as () => void);
    };
  }, [handler]);
  return (
    <>
      {isHeaderLoad && (
        <div className="toastContainer" style={{ top: headerHeightCal }}>
          {alerts.map(({ message, type }, idx) => (
            <div
              className={`toastContainer__alert ${styleAlert}`}
              key={idx}
              role="alert"
              aria-live="polite"
            >
              <Icon type={type} />
              <p>{message}</p>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default ToastBanner;
